import classNames from "classnames";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";

interface Props {
  correct: boolean;
  text: string;
}

export default function TechniqueAnswerChip({ correct, text }: Props) {
  return (
    <div
      className={classNames(
        "mb-2 mr-2 inline-flex items-center rounded border-2 py-0.5 pl-1 pr-2 font-brik",
        {
          "border-green-500": correct,
          "border-red-500": !correct,
        }
      )}
    >
      {correct ? (
        <CheckCircleIcon className={"mr-1 h-5 text-green-500"} />
      ) : (
        <XCircleIcon className={"mr-1 h-5 text-red-500"} />
      )}

      {text}
    </div>
  );
}
